import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../../../../Common/Styles/Icons.module.scss";
import { Application } from "../../../../App/Models/Application";
import { appPaths } from "../../../../Common";
import { BadgeButton } from "../../../../Layout/Components/BadgeButton/BadgeButton";
import ElementSpacer from "../../../../Layout/Components/ElementSpacer";

type Props = {
  app: Application;
};

type State = {
  app: Application;
};

class FeedbackAppBadge extends React.Component<Props & RouteComponentProps, State> {
  constructor(props: Props & RouteComponentProps) {
    super(props);

    this.state = {
      app: this.props.app
    };
  }

  onClick = () => {
    this.props.history.push(appPaths.app.root.replace(":id", this.state.app.rolePrefix));
  };

  render() {
    return (
      <BadgeButton
        onClick={this.onClick}
        title={`Click here to see all feedback for ${this.state.app.name}`}
      >
        <ElementSpacer spacing=".25rem">
          <span>
            <Icon
              appName="GeneralLayout"
              assetName="GENERAL_L_Search"
              className={iconStyles.smallIcon}
            />
          </span>
          {this.state.app.name}
        </ElementSpacer>
      </BadgeButton>
    );
  }
}

export default withRouter(FeedbackAppBadge);
